import React from "react";

// Static left-hand column of the Agenda section (copy + duration card).
export const AgendaIntro = () => (
  <header className="cfa-intro">
    <p className="cfa-eyebrow">Your evening at a glance</p>
    <h2 id="cpf-agenda-title">A focused two-hour session.</h2>
    <p className="cfa-intro__copy">
      No long lectures. Just a clear sequence of explanations, practical scenarios and time for your questions.
    </p>

    <div className="cfa-duration-card">
      <span className="cfa-clock" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v6l4 2" />
        </svg>
      </span>
      <span className="cfa-duration-card__copy">
        <strong>2-hour main programme</strong>
        <small>7:00PM&ndash;9:00PM &middot; Designed to be focused</small>
      </span>
    </div>

    <p className="cfa-interaction-note"><i aria-hidden="true" /> Select each item to explore the evening</p>
  </header>
);

export const AgendaBackground = () => (
  <div className="cfa-background" aria-hidden="true">
    <span className="cfa-aurora cfa-aurora--gold" />
    <span className="cfa-aurora cfa-aurora--teal" />
    <span className="cfa-ring" />
    <span className="cfa-particle cfa-particle--one" />
    <span className="cfa-particle cfa-particle--two" />
    <span className="cfa-particle cfa-particle--three" />
  </div>
);
